import React, {useEffect, useState} from "react";
import Dialog from "../../base/dialog";
import {Row} from "reactstrap";
import {DialogActions, DialogContent, DialogTitle, Divider} from "@mui/material";
import Button from "../../base/button/button";

const configInitState = {child: null, props: {}, onClose: null, cancelText: 'Cancel', proceedText: 'Proceed'}

const ConfirmationDialog = () => {
    const [open, setOpen] = useState(false)
    const [config, setConfig] = useState(configInitState)

    /**
     * As soon as the component mounts:
     * - sets the global callback for opening this modal
     * Removes the set callback as soon as the component un-mounts.
     */
    useEffect(() => {
        window.partner = {
            ...(window.partner ?? {}),
            openConfirmationDialog: onOpen
        }
        return () => {
            delete window?.partner?.openConfirmationDialog;
        }
    }, [])


    /**
     * Opens the dialog and sets the configuration passed into it
     * @param {React.ReactNode} child the dynamic children of the dialog
     * @param {any} props the properties used in the modal
     * @param {string} proceedText text for proceed button
     * @param {string} cancelText text for cancel button
     * @param {function(boolean): void} onClose a function for receiving the decicion of the user.
     */
    const onOpen = (child, props, onClose, proceedText = configInitState.proceedText, cancelText = configInitState.cancelText) => {
        setConfig({child, props: props ?? {}, onClose, proceedText: proceedText, cancelText: cancelText})
        setOpen(true)
    }

    /**
     * Closes the modal and invokes the onClose callback set in the configurations.
     * @param {boolean | null} success
     */
    const onClose = (success = false) => {
        setOpen(false)
        if (config.onClose) {
            config.onClose(success)
        }
        setConfig(configInitState)
    }

    return (
        <>
            <Dialog
                maxWidth={'sm'}
                {...(config.props ?? {})}
                open={open}
                setOpen={() => onClose(false)}>
                <DialogTitle className={'pb-0 px-0'}>
                    <Row xs={12} className='no-gutters justify-content-center w-100'>
                        <p className={`text-lg text-color-1 my-2 font-weight-semi-bold text-center`}>
                            Confirmation
                        </p>
                    </Row>
                    <Divider className='divider'/>
                </DialogTitle>
                <DialogContent>
                    {
                        config.child
                        ?? <div className={'p-3'}>
                            <p className={'text-sm text-color-2'}>
                                Would you like to proceed with the requested operation?
                            </p>
                        </div>
                    }
                    <div className='my-2 w-100'/>
                </DialogContent>
                <DialogActions className={'p-0'}>
                    <Row className={'w-100 no-gutters'}>
                        <Divider className='divider'/>
                        <Row className='no-gutters justify-content-between align-items-start w-100'>
                            <Button
                                disabled={!open}
                                variant={'dialog'}
                                color={'primary'}
                                onClick={() => onClose(false)}
                                borderRadius={'0 8px 0 8px'}
                            >
                                {config.cancelText}
                            </Button>
                            <Button
                                disabled={!open}
                                variant={'dialog'}
                                color={'primary'}
                                onClick={() => onClose(true)}
                                borderRadius={'8px 0 8px 0'}
                            >
                                {config.proceedText}
                            </Button>
                        </Row>
                    </Row>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default ConfirmationDialog;
